import React from 'react';
import { formatItineraryInfo, getRatingLabel } from '../../../helpers/cruiseSearchHelper';
import { __ } from '../../../helpers/TranslationService';
import { Rating } from './Rating';
import { getCruiseTitle } from '../../../helpers/cruisePageHelpers';

export const SearchResultItemTopDesktopSection = (props: any) => {
    const { wayPointCities, nights, cruiseRating, cruiseRatingCount, companyNid } = props.cruise;
    const uniqueWayPointCities = Array.from(new Set(wayPointCities));
    const nightsPortsDaysAtSea = formatItineraryInfo(nights, uniqueWayPointCities.length);
    const destination = props.cruise?.areaTitles.length ? props.cruise.areaTitles[0] : '';

    const title = getCruiseTitle({
        isDreamlinesPackage: props.cruise.isPackageCruise,
        companyNid: companyNid,
        shipTitle: props.cruise.shipTitle,
        cruiseTitle: props.cruise.routeTitle,
        companyTitle: props.cruise.companyTitle,
        destination: destination,
        startHarbour: props.cruise.startHarbourName,
    });

    return (
        <>
            <div className="searchResultItemTopDesktopSection">
                <div className="searchResultItemTopDesktopSection__leftSide">
                    <div className="searchResultItemTopDesktopSection__nightsAndHarbours">
                        {nightsPortsDaysAtSea}
                    </div>
                    <div className="searchResultItemTopDesktopSection__headline">{title}</div>
                </div>
                <div className="searchResultItemTopDesktopSection__rightSide">
                    {cruiseRating > 0 && (
                        <Rating
                            value={cruiseRating * 2}
                            string={getRatingLabel(cruiseRating * 2)}
                            amount={cruiseRatingCount}
                        />
                    )}
                </div>
            </div>
            <div className="hr" />
        </>
    );
};
